import type { TFunction } from 'i18next';

import i18n, { DEFAULT_LOCALE, NAMESPACE } from '@app/i18n';

/** Localized `current / max` counter. Plural uses `max`. `includeNoun: false` keeps English as `N / NNN`. */
export const formatCharacterCount = (
  t: TFunction,
  current: number,
  max: number,
  options?: { includeNoun?: boolean },
): string => {
  if (options?.includeNoun === false && i18n.language === DEFAULT_LOCALE) {
    return `${current} / ${max}`;
  }
  return t(`${NAMESPACE.COMMON}:characterCount`, {
    count: max,
    current,
    max,
  });
};

/** Localized unbounded counter for fields with no max length, e.g. "Approximate message length: N characters". */
export const formatApproximateCharacterCount = (
  t: TFunction,
  current: number,
): string =>
  t(`${NAMESPACE.COMMON}:approximateCharacterCount`, { count: current });
